import React from 'react';
import styled from 'styled-components';
import { CheckCircle, Circle } from 'phosphor-react';
import { FormControlLabel } from '../../components/FormControlLabel/FormControlLabel';
import { RadioGroup } from '@mui/material';
import { renderToStaticMarkup } from 'react-dom/server';
import { theme } from '../../styles/theme';
const reactSvgComponentToMarkupString = (Component) => `data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(React.createElement(Component)))}`;
export const Wrapper = styled(RadioGroup) `
  && {
    flex-direction: row;
    gap: ${theme.spacing.sm};
  }
`;
export const Radio = styled(FormControlLabel) `
  && {
    ${theme.typography.bodyLG};
    background: ${theme.colors.backgroundPrimary};
    border: 1px solid ${theme.colors.borderDark};
    border-radius: ${theme.spacing.xs};
    color: ${theme.colors.textBrand};
    height: 48px;
    margin: 0;
    padding: ${theme.spacing.sm} ${theme.spacing.lg} ${theme.spacing.sm}
      ${theme.spacing.md};

    .MuiRadio-root {
      background: ${() => `url(${reactSvgComponentToMarkupString(Circle)})`};
      background-size: cover;
      margin-right: ${theme.spacing.xs};
      opacity: 0.2;
      padding: 0;

      svg {
        visibility: hidden;
      }
    }

    &:has(:checked) {
      background: ${theme.colors.backgroundBrandLight};
      border-color: ${theme.colors.borderBrand};

      .MuiRadio-root {
        background-image: ${() => `url(${reactSvgComponentToMarkupString(CheckCircle)})`};
        opacity: 1;
      }
    }
  }
`;
